module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-bg login-bg",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6"
  }, [_c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_c('div', {
    staticClass: "swal2-show"
  }, [(_vm.unsubscribeStatus === 'success') ? _c('div', {
    staticClass: "swal2-icon swal2-success swal2-animate-success-icon",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "swal2-success-circular-line-left",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-tip swal2-animate-success-line-tip"
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-long swal2-animate-success-line-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-ring"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-fix",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-circular-line-right",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  })]) : (_vm.unsubscribeStatus === 'error') ? _c('div', {
    staticClass: "swal2-icon swal2-error swal2-animate-error-icon",
    staticStyle: {
      "display": "block",
      "margin-top": "0",
      "margin-bottom": "20px"
    }
  }, [_c('span', {
    staticClass: "swal2-x-mark swal2-animate-x-mark"
  }, [_c('span', {
    staticClass: "swal2-x-mark-line-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-x-mark-line-right"
  })])]) : _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-5x fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), (_vm.unsubscribeStatus === 'success') ? _c('p', {
    staticClass: "lead text-center"
  }, [_vm._v("Successfully Unsubscribed.")]) : (_vm.unsubscribeStatus === 'error') ? _c('p', {
    staticClass: "lead text-center"
  }, [_vm._v("Unauthorized.")]) : _c('p', {
    staticClass: "lead text-center"
  }, [_vm._v("...")])]), _vm._v(" "), _c('div', {
    staticClass: "login-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.login'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" Back to Login")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.register'
      }
    }
  }, [_vm._v("Register")])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('h1', [_vm._v("Unsubscribing...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-16c632ff"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Unsubscribe.vue
// module id = 938
// module chunks = 0